/*
 * @Author: 李明明
 * @Date: 2022-09-16 15:10:15
 * @LastEditTime: 2024-08-06 17:15:14
 * @LastEditors: 李明明
 * @Description:
 * @FilePath: /ykt-micro-main/src/api/course.js
 * 代码版权方：'政府采购信息网'
 */
import axios from "@/utils/axios";
let { post, uploadFiles } = axios;
// 获取课程内章节列表
export const listColumn = (data) => post("/study/listColumnNew", data);
// 获取章节下的视频数据
export const listDataArticle = (data) =>
  post("/study/listDataArticleNew", data);
// 获取视频相关信息
export const onlineVideo = (data) => post("/study/onlineVideo", data);
// 监听学习进度接口
export const monitorProcess = (data) => post("/study/monitorProcess", data);
// 获取学习进度接口
export const listProcess = (data) => post("/study/listProcess", data);
// 获取表单信息
export const getCourseFormInformation = (data) =>
  post("/study/getCourseFormInformation", data);
// 回答锚点接口
export const onlineAnswer = (data) => post("/study/onlineAnswer", data);
// 修改课程自动播放状态
export const updateChooseAutomaticPlayVideo = (data) =>
  post("/study/updateChooseAutomaticPlayVideo", data);
// 获取选修课栏目列表
export const listColumnOptionalCourse = (data) =>
  post("/study/listColumnOptionalCourse", data);
// 获取选修课栏目下的课程列表
export const listDataArticleOptionalCourse = (data) =>
  post("/study/listDataArticleOptionalCourse", data);
// 获取学习中学员信息
export const getStudentInfo = (data) => post("/study/getStudentInfo", data);
// 修改学习中的学员信息
export const updateStudent = (data) =>
  uploadFiles("/study/updateStudent", data);
// 获取学习中人脸识别ID
export const getStudyFaceId = (data) => post("/study/getStudyFaceId", data);
// 验证学习中人脸识别
export const verifyStudyFaceResult = (data) =>
  post("/study/verifyStudyFaceResult", data);
// 用户修改随堂小考状态
export const updateUserAnchorStatus = (data) =>
  post("/study/updateUserAnchorStatus", data);
// C端研修班报名
export const enrollPartialFreeCourse = (data) =>
  post("/seminar/enrollPartialFreeCourse", data);
// 获取用户卡券信息
export const getGiveProduct = (data) =>
  post("/seminar/getGiveProduct", data);

// 领取卡券
export const obtainGiveProduct = (data) =>
  post("/seminar/obtainGiveProduct", data);